import styled from 'styled-components';

export const MainWrapper = styled.div`
  background: #e9eaee;
`;

export const Container = styled.div`
  max-width: 991px;
  margin: 70px auto 54px;
`;
